var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.129,
    height: 24.147,
    viewBox: "0 0 21.129 24.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#405cfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab5fc"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-calendar-check",
    "data-name": "Icon awesome-calendar-check",
    d: "M20.563,7.546h-20A.566.566,0,0,1,0,6.98v-1.7A2.264,2.264,0,0,1,2.264,3.018H4.528V.566A.566.566,0,0,1,5.094,0H6.98a.566.566,0,0,1,.566.566V3.018h6.037V.566A.566.566,0,0,1,14.149,0h1.887A.566.566,0,0,1,16.6.566V3.018h2.264a2.264,2.264,0,0,1,2.264,2.264v1.7A.566.566,0,0,1,20.563,7.546Zm-20,1.509h20a.566.566,0,0,1,.566.566V21.884a2.264,2.264,0,0,1-2.264,2.264H2.264A2.264,2.264,0,0,1,0,21.884V9.621A.566.566,0,0,1,.566,9.055ZM16.285,13.58l-1.329-1.339a.566.566,0,0,0-.8,0l-5,4.961L6.987,15.013a.566.566,0,0,0-.8,0L4.847,16.338a.566.566,0,0,0,0,.8l3.9,3.927a.566.566,0,0,0,.8,0l6.742-6.688a.566.566,0,0,0,0-.8Z",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCheck);
export default __webpack_public_path__ + "static/media/calendar-check.c998e9060fc6eab3fbe3ab9848a36827.svg";
export { ForwardRef as ReactComponent };